import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
// import Link from '@mui/material/Link';
import {Link} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import './CustomSeparator.css';

export default function CustomSeparator({currentCrumbs}) {
  const breadcrumbs = [
    <Link key="1" to="/">
      Nuts
    </Link>,
    <Link
    key="2"
      to="/categories"
    >
      Categories
    </Link>,
    <Typography key="3" color="text.primary">
      {currentCrumbs}
    </Typography>,
  ];

  return (
    <div className="container mt-2 separator">
      <div className="row">
        <div className="col">
          <Stack spacing={2}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Stack>
        </div>
      </div>
    </div>
  );
}
